import { WidgetType } from 'shared/widgets/utils';

import { createNewOpenQuestionData } from './create';
import { manifestLocales } from './manifest.locales';
import OpenQuestionEn from './resources/en/open-question.svg';
import OpenQuestionHe from './resources/he/open-question.svg';
import { QuestionsCircles } from '@/icons/QuestionsCircles';
import { ManifestType } from '@/types/ManifestType';

export const Manifest: ManifestType = {
  name: WidgetType.OpenQuestion,
  previewGroups: [
    {
      id: 'openQuestion',
      divider: {
        icon: QuestionsCircles,
        title: 'openQuestion'
      },
      previews: [
        {
          name: 'openQuestionPreview',
          previewImage: {
            paths: {
              en: OpenQuestionEn,
              he: OpenQuestionHe
            },
            size: {
              width: 140,
              height: 122
            },
            alt: { ...manifestLocales.openQuestion.previewOpenQuestionAlt }
          },
          dimensions: {
            width: 1180,
            height: 'auto'
          },
          initializeProps: createNewOpenQuestionData
        }
      ]
    }
  ],
  additionalData: {
    constraints: {
      minHeight: 48,
      minWidth: 100
    }
  }
};
